import packageJson from '../../../package.json';

/**
 * ゲーム全体の設定を管理するオブジェクト
 */
export const GameConfig = {
  // ゲームのバージョン情報（package.jsonから取得）
  version: packageJson.version,
  
  // 他の設定値も必要に応じて追加
};
